import { render, staticRenderFns } from "./ContainerAbout.vue?vue&type=template&id=62e06190&scoped=true&"
import script from "./ContainerAbout.vue?vue&type=script&lang=js&"
export * from "./ContainerAbout.vue?vue&type=script&lang=js&"
import style0 from "./ContainerAbout.vue?vue&type=style&index=0&id=62e06190&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e06190",
  null
  
)

export default component.exports